.cc-no-result__icon {
  width: 64px;
  margin: 0 auto 13px;
  color: rgba(51, 51, 51, 0.5);
}

.cc-no-result__label {
  font-size: 12px;
  line-height: 18px;
  font-weight: bold;
  text-align: center;
  color: #626469;
}